import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home/Home'
import Login from '@/pages/Auth/Login'
import Register from '@/pages/Auth/Register'
import Tutorial from '@/pages/Tutorial/Tutorial'
import HelpsContent from '@/pages/Tutorial/components/HelpsContent'
import HelpsArticle from '@/pages/Tutorial/components/HelpsArticle'
import HasMoreArticle from '@/pages/Tutorial/components/HasMoreArticle'
import Buy from "@/pages/Buy/Buy"
import Download from "@/pages/Download/Download"
import Personal from "@/pages/Personal/Personal"
import changepwd from "@/pages/Personal/components/changepwd"
import changeemail from "@/pages/Personal/components/changeemail"
import changephone from "@/pages/Personal/components/changephone"
import bindingphone from "@/pages/Personal/components/bindingphone"
import Weixinpay from '@/pages/Personal/components/Weixinpay'
import test from '@/pages/Auth/test'
import error from '@/Error/error'


import InvoiceModify from '@/pages/Personal/components/InvoiceModify'
import Invoice from '@/pages/Personal/components/Invoice'


const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const router = new Router({
  // mode: 'history',//开启预渲染一定要开这个
  // scrollBehavior:()=>{ //禁止浏览器前进后退按钮
  //   history.pushState(null,null,document.URL)
  // },
  routes: [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component:resolve => require(['@/pages/Home/Home'], resolve),
    // },   
    {
      path: '/',
      component:resolve => require(['@/pages/Personal/Personal'], resolve),
    },
    {
      path: '/Login',
      name: 'Login',
      component:resolve => require(['@/pages/Auth/Login'], resolve),
    },
    {
      path: '/Register',
      name: 'Register',
      component:resolve => require(['@/pages/Auth/Register'], resolve),
    },
    {
      path: '/Tutorial',
      name: 'Tutorial',
      component:resolve => require(['@/pages/Tutorial/Tutorial'], resolve),
      children: [
        {
          path: '/HelpsContent',
          name: 'HelpsContent',
          component:resolve => require(['@/pages/Tutorial/components/HelpsContent'], resolve)
        },
        {
          path: '/HelpsArticle',
          name:'HelpsArticle',
          component:resolve => require(['@/pages/Tutorial/components/HelpsArticle'], resolve)
        },
        {
          path: '/HasMoreArticle',
          name: 'HasMoreArticle',
          component:resolve => require(['@/pages/Tutorial/components/HasMoreArticle'], resolve)
        }
      ]
    },
    {
      path: '/Buy',
      name: 'Buy',
      component:resolve => require(['@/pages/Buy/Buy'], resolve),
    },
    {
      path: '/payment',
      name: 'payment',
      component:resolve => require(['@/pages/Personal/components/Weixinpay'], resolve)
    },
    {
      path: '/Download',
      name: 'Download',
      component:resolve => require(['@/pages/Download/Download'], resolve),
      alias: 'Download'
    },
    {
      path: '/Personal',
      name: 'Personal',
      component:resolve => require(['@/pages/Personal/Personal'], resolve),
      children: [
        {
          path:'changepwd',
          component:resolve => require(['@/pages/Personal/components/changepwd'], resolve),
        },
        {
          path:'changeemail',
          component:resolve => require(['@/pages/Personal/components/changeemail'], resolve),
        },
        {
          path:'changephone',
          component:resolve => require(['@/pages/Personal/components/changephone'], resolve),
        },
        {
          path:'bindingphone',
          component:resolve => require(['@/pages/Personal/components/bindingphone'], resolve),
        },
        //2020-8-4
        {
          path: 'invoicemodify',
          name: 'InvoiceModify',
          component: resolve => require(['@/pages/Personal/components/InvoiceModify'], resolve),
        }, 
        {
          path: 'invoice',
          name: 'Invoice',
          component: resolve => require(['@/pages/Personal/components/Invoice'], resolve),
        }
      ]
    },
    {
      path: '/404',
      name: '404',
      component:resolve => require(['@/Error/error'], resolve),
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js